var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Apps } from '../entities/Utils';
import { abcLocales, juniorLocales } from '../constants';
import { get } from 'lodash';
import ContentAPIService from './contentAPIService';
export default class TranslationService {
    constructor(props) {
        this.config = props.config;
        this.getContentSignature = props.getContentSignature;
        this.language = { abc: {}, junior: {} };
    }
    loadLanguage(app, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkIfLanguageExists(locale);
            const contentAPIService = new ContentAPIService(Object.assign(Object.assign({}, this.config), { getContentSignature: this.getContentSignature }));
            this.language[app] = yield contentAPIService.load(`${app}/languages/${locale}.json`);
        });
    }
    checkIfLanguageExists(locale) {
        var _a;
        const configs = {
            [Apps.junior]: juniorLocales,
            [Apps.abc]: abcLocales,
        };
        if (!((_a = configs[this.config.app]) === null || _a === void 0 ? void 0 : _a.includes(locale))) {
            throw new Error(`Tried to load "${locale}, but this language is not present."`);
        }
    }
    get(props) {
        const { app, locale, translationKey } = props;
        this.checkIfLanguageExists(locale);
        if (translationKey === '') {
            return this.language[app];
        }
        return get(this.language[app], translationKey);
    }
}
//# sourceMappingURL=translationService.js.map